import 'svelte/internal/disclose-version';
import * as $ from 'svelte/internal/client';
import { bindPropStore } from "../bindProps";
import { text } from "../helpers";
import InlineIcon from "../InlineIcon.svelte";

var root = $.from_html(`<span> </span>`);
var root_1 = $.from_html(`<div class="slex-progress-label"><!> <!></div>`);
var root_2 = $.from_html(`<div class="slex-progress" data-scope="progress" role="progressbar"><!> <div class="slex-progress-track"><div class="slex-progress-range"></div></div></div>`);

export default function Progress($$anchor, $$props) {
	$.push($$props, true);

	let p = $.state($.proxy({}));

	$.user_effect(() => bindPropStore($$props.props, (next) => $.set(p, next, true)));

	function value() {
		const next = Number($.get(p).value ?? 0);

		return Number.isFinite(next) ? Math.min(100, Math.max(0, next)) : 0;
	}

	var div = root_2();
	var node = $.child(div);

	{
		var consequent_2 = ($$anchor) => {
			var div_1 = root_1();
			var node_1 = $.child(div_1);

			{
				var consequent = ($$anchor) => {
					InlineIcon($$anchor, {
						get name() {
							return $.get(p).icon;
						},
						className: 'slex-progress-icon'
					});
				};

				$.if(node_1, ($$render) => {
					if ($.get(p).icon) $$render(consequent);
				});
			}

			var node_2 = $.sibling(node_1, 2);

			{
				var consequent_1 = ($$anchor) => {
					var span = root();
					var text_1 = $.child(span, true);

					$.reset(span);
					$.template_effect(($0) => $.set_text(text_1, $0), [() => text($.get(p).label)]);
					$.append($$anchor, span);
				};

				$.if(node_2, ($$render) => {
					if ($.get(p).label) $$render(consequent_1);
				});
			}

			$.reset(div_1);
			$.append($$anchor, div_1);
		};

		$.if(node, ($$render) => {
			if ($.get(p).label || $.get(p).icon) $$render(consequent_2);
		});
	}

	var div_2 = $.sibling(node, 2);
	var div_3 = $.child(div_2);
	let styles;

	$.reset(div_2);
	$.reset(div);

	$.template_effect(
		($0, $1, $2) => {
			$.set_attribute(div, 'data-state', $.get(p).indeterminate ? "indeterminate" : "determinate");
			$.set_attribute(div, 'aria-label', $0);
			$.set_attribute(div, 'aria-valuemin', $.get(p).indeterminate ? undefined : 0);
			$.set_attribute(div, 'aria-valuemax', $.get(p).indeterminate ? undefined : 100);
			$.set_attribute(div, 'aria-valuenow', $1);
			styles = $.set_style(div_3, '', styles, $2);
		},
		[
			() => text($.get(p)["aria-label"] ?? $.get(p).ariaLabel ?? $.get(p).label) || undefined,
			() => $.get(p).indeterminate ? undefined : value(),
			() => ({ width: `${value()}%` })
		]
	);

	$.append($$anchor, div);
	$.pop();
}